(function () {
  'use strict';

  var searchInput = document.getElementById('ksup-search');
  var categorySelect = document.getElementById('ksup-category-filter');
  var grid = document.getElementById('ksup-grid');
  var emptyMsg = document.getElementById('ksup-grid-empty');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.ksup-card')) : [];

  function applyFilters() {
    var query = (searchInput && searchInput.value || '').trim().toLowerCase();
    var category = categorySelect ? categorySelect.value : '';
    var visibleCount = 0;

    cards.forEach(function (card) {
      var matchesCategory = !category || card.dataset.category === category;
      var matchesQuery = !query || card.dataset.title.indexOf(query) !== -1;
      var visible = matchesCategory && matchesQuery;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (categorySelect) categorySelect.addEventListener('change', applyFilters);

  /* ---------- Real add-to-cart for refill cards (kitsters-card-product snippet) ---------- */
  var badge = document.querySelector('[data-cart-count]');
  var toast = document.querySelector('[data-toast]');
  var toastText = toast ? toast.querySelector('[data-toast-text]') : null;
  var toastCloseBtn = toast ? toast.querySelector('[data-toast-close]') : null;
  var toastTimer;

  function showToast(msg) {
    if (!toast || !toastText) return;
    toastText.textContent = msg;
    toast.classList.remove('is-open');
    void toast.offsetWidth;
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-open'); }, 4000);
  }
  if (toastCloseBtn) {
    toastCloseBtn.addEventListener('click', function () {
      toast.classList.remove('is-open');
      clearTimeout(toastTimer);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var name = btn.getAttribute('data-name') || 'Item';
    if (!variantId) return;

    btn.disabled = true;

    // KitstersCart owns the drawer contract — which sections to request and
    // how to hand the response back. See assets/kitsters-cart-bridge.js.
    var payload = { id: parseInt(variantId, 10), quantity: 1 };

    window.KitstersCart.addToCart(payload)
      .then(function () {
        showToast(name + ' added to cart!');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('is-empty', cart.item_count === 0);
        }
      })
      .catch(function (err) {
        showToast((err && err.cartError && err.cartError.description) || 'Could not add to cart - please try again');
      })
      .finally(function () { btn.disabled = false; });
  });
})();
